import SyncErrorType from '@/wdm-common/Syncing/SyncErrorType';
import SyncState from '@/wdm-common/Syncing/SyncState';

export const finalStateMessages = [
    'Reticulating splines',
    'Testing your patience',
    'Spinning up hamsters',
    'Programming flux capacitor',
    'Loading humorous message',
    'Warming up Large Hadron Collider',
    'Walking the dog',
    'You still there?',
    'Calculating meaning of life',
    'Entering the matrix',
    'Contemplating',
    'Have a good day',
    'Baking cookies',
    'Computing chance of success',
    'Dividing by zero',
    '// TODO make more funny messages',
    'Consulting the manual',
    'Help, I\'m trapped in a progress bar',
];

export const syncProgressMessages = {
    [SyncState.CHECK_CONNECTIVITY]: {
        percent: 5,
        text: 'Checking connectivity...',
    },
    [SyncState.LOGIN_FB]: {
        percent: 10,
        text: 'Logging in...',
    },
    [SyncState.LOGIN_WDM]: {
        percent: 20,
        text: 'Logging in to Who Deleted Me...',
    },
    [SyncState.IMPORT_FRIENDS]: {
        percent: 30,
        text: 'Importing your previous Who Deleted Me data...',
    },
    [SyncState.FETCH_FRIENDS]: {
        percent: 40,
        text: 'Finding friends...',
    },
    // [SyncState.FETCH_FRIENDS_SLOW]: {
    //     percent: 50,
    //     text: 'Downloading friends...',
    // },
    [SyncState.SAVE_FRIENDS]: {
        percent: 60,
        text: 'Saving your friends...',
    },
    [SyncState.CALCULATE_FRIENDS]: {
        percent: 70,
        text: 'Calculating who deleted you...',
    },
    [SyncState.SAVE_RESULTS]: {
        percent: 80,
        text: 'Saving results...',
    },
    [SyncState.SEND_RESULTS]: {
        percent: 85,
        text: 'Sending results...',
    },
    // [SyncState.CHECK_DEACTIVATE]: {
    //     percent: 75,
    //     text: 'Checking who deactivated...',
    // },
    // [SyncState.SAVE_STATUS]: {
    //     percent: 90,
    //     text: 'Updating friend status...',
    // },
    // [SyncState.FINISHED]: {
    //     percent: 95,
    //     text: 'Finished!', // This is replaced with a random message in SyncView.
    // },
};

export const syncErrorMessages = {
    [SyncErrorType.FB_OFFLINE]: {
        title: 'Unable to connect to FB.',
        desc: 'Check that you are connected to the internet and try again.',
    },

    [SyncErrorType.API_OFFLINE]: {
        title: 'Unable to connect to Who Deleted Me.',
        desc: 'Please try again in a few minutes.',
    },

    [SyncErrorType.FB_NOT_LOGGED_IN]: {
        title: 'Are you logged in to FB?',
        desc: 'You need to be logged in to FB while using Who Deleted Me. Please login and then try again.',
    },

    [SyncErrorType.NO_FB_USER]: {
        title: 'Failed to load your FB profile',
        desc: 'There was a problem reading your FB profile. Please check you are logged in to FB then try again. If this error keeps happening please contact us for help.',
    },

    [SyncErrorType.READ_FB_USER_FAILED]: {
        title: 'Failed to load your FB profile',
        desc: 'There was a problem reading your FB profile. Please check you are logged in to FB then try again. If this error keeps happening please contact us for help.',
    },

    [SyncErrorType.LOGIN_WDM_FAILED]: {
        title: 'Failed to login to Who Deleted Me',
        desc: 'If this problem keeps happening please contact us.',
    },

    [SyncErrorType.IMPORT_FRIENDS_FAILED]: {
        title: 'Failed to import your previous Who Deleted Me data',
        desc: 'If this problem keeps happening please contact us.',
    },

    [SyncErrorType.FETCH_FRIENDS_FAILED]: {
        title: 'Unable to read your friend list.',
        desc: 'Please make sure you\'re logged in and then try again. If this error keeps happening please contact us for help.',
    },

    [SyncErrorType.SAVE_FRIENDS_FAILED]: {
        title: 'Failed to save friends.',
        desc: 'There was a problem saving your friend list.',
    },

    [SyncErrorType.CALCULATE_FRIENDS_FAILED]: {
        title: 'Failed to check changes.',
        desc: 'There was a problem while we were calculating who has deleted you.',
    },

    [SyncErrorType.SEND_RESULTS_FAILED]: {
        title: 'Failed to send results.',
        desc: 'There was a problem while we were sending the results of who deleted you from the extension to your browser.',
    },

    [SyncErrorType.SAVE_RESULTS_FAILED]: {
        title: 'Failed to save results.',
        desc: 'There was a problem while we were saving the results of who deleted you.',
    },

    [SyncErrorType.API_ERROR]: {
        title: 'Uh-Oh!',
        desc: 'There was a problem saving your friend list.',
    },

    [SyncErrorType.NO_EXTENSION]: {
        title: 'Do you have the Who Deleted Me browser extension?',
        desc: 'You need to install the browser extension to make Who Deleted Me work.',
        showGetExtensionButton: true,
    },
    [SyncErrorType.TIMEOUT]: {
        title: 'Unable to sync your friends.',
        desc: 'Sorry, it took too long to check who deleted you. This may be a problem with your browser extension or with FB. If this error keeps happening please contact us for help.',
    },
};
